export const base_url = "/react/template";
// export const base_url = "/hrms";
